import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@olxbr/ds-core'
import styled from 'styled-components'

const ButtonCaption = styled(Button).attrs({ variant: 'link' })`
  font-size: var(--font-size-1-5);
  padding: 0;
  font-weight: 600;
  outline: 0;
  border: 0;

  &:hover {
    background-color: transparent !important;
    border: 0;
  }
`

export const CaptionButton = ({ description, buttonDescription, onClick }) => {
  return (
    <span className="typo-caption text-neutral-120">
      {description}
      <ButtonCaption onClick={onClick()}>{buttonDescription}</ButtonCaption>
    </span>
  )
}

CaptionButton.propTypes = {
  description: PropTypes.string,
  buttonDescription: PropTypes.string,
  onClick: PropTypes.func,
}
